import { Media } from '@/payload-types'

/**
 * Derives file type from Media object
 * Extracts from mimeType (e.g., "application/pdf" → "PDF")
 * Falls back to filename extension if mimeType unavailable
 * @param file - Media object
 * @returns Uppercase file type string (e.g., "PDF", "DOCX")
 */
export function getFileType(file: Media | string | null | undefined): string | null {
  if (!file) return null

  // Handle string (ID reference)
  if (typeof file === 'string') return null

  // Extract from mimeType
  if (file.mimeType) {
    const mimeType = file.mimeType.toLowerCase()
    
    // Common mime type mappings
    if (mimeType.includes('pdf')) return 'PDF'
    if (mimeType.includes('word') || mimeType.includes('document')) return 'DOCX'
    if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) return 'XLSX'
    if (mimeType.includes('powerpoint') || mimeType.includes('presentation')) return 'PPTX'
    if (mimeType.includes('text')) return 'TXT'
    if (mimeType.includes('csv')) return 'CSV'
    
    // Extract extension from mime type (e.g., "application/vnd.openxmlformats-officedocument.wordprocessingml.document" → "DOCX")
    const parts = mimeType.split('/')
    if (parts.length > 1) {
      const subtype = parts[1]
      if (subtype) {
        if (subtype.includes('pdf')) return 'PDF'
        if (subtype.includes('word') || subtype.includes('document')) return 'DOCX'
        if (subtype.includes('excel') || subtype.includes('spreadsheet')) return 'XLSX'
        if (subtype.includes('powerpoint') || subtype.includes('presentation')) return 'PPTX'
      }
    }
  }

  // Fallback to filename extension
  if (file.filename) {
    const extension = file.filename.split('.').pop()?.toUpperCase()
    if (extension) {
      // Map common extensions
      const extensionMap: Record<string, string> = {
        PDF: 'PDF',
        DOC: 'DOC',
        DOCX: 'DOCX',
        XLS: 'XLS',
        XLSX: 'XLSX',
        PPT: 'PPT',
        PPTX: 'PPTX',
        TXT: 'TXT',
        CSV: 'CSV',
      }
      return extensionMap[extension] || extension
    }
  }

  return null
}

